module.exports = __webpack_public_path__ + "img/3-2-2.2714cd54.svg";